import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      !_setup.filtersStore.hasUnsavedFilters
        ? _c(
            VBtn,
            {
              staticClass: "bg-primary",
              attrs: { text: "", block: "", depressed: "", color: "primary" },
              on: {
                click: function ($event) {
                  return _vm.$emit("click:close")
                },
              },
            },
            [
              _vm._v(
                "\n    " + _vm._s(_setup.t("Закрыть", _setup.options)) + "\n  "
              ),
            ]
          )
        : !_setup.countLpu && !_setup.loading
        ? _c(
            VBtn,
            {
              attrs: {
                block: "",
                depressed: "",
                disabled: "",
                color: "primary",
              },
            },
            [
              _vm._v(
                "\n    " +
                  _vm._s(_setup.t("Не найдено", _setup.options)) +
                  "\n  "
              ),
            ]
          )
        : _c(
            VBtn,
            {
              attrs: {
                block: "",
                depressed: "",
                type: "submit",
                color: "primary",
                "data-filters-yandex-goals": "filter-lpu-list-result-show",
                loading: _setup.loading,
              },
              on: {
                click: function ($event) {
                  return _vm.$emit("click:submit")
                },
              },
            },
            [
              _setup.countLpu
                ? [
                    _vm._v(
                      "\n      " +
                        _vm._s(_setup.t("Показать", _setup.options)) +
                        "\n      " +
                        _vm._s(_setup.countLpu.toLocaleString("ru-RU")) +
                        "\n      " +
                        _vm._s(
                          _setup.t(
                            _setup.getNounCase(_setup.countLpu, [
                              "клинику",
                              "клиники",
                              "клиник",
                            ]),
                            _setup.options
                          )
                        ) +
                        "\n    "
                    ),
                  ]
                : _vm._e(),
            ],
            2
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }